<template>
  <el-dialog
    title="修改供应商"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="editForm"
      :model="editResourceSupplierInfo"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="供应商名称" prop="supplierName">
        <el-input
          v-model="editResourceSupplierInfo.supplierName"
          placeholder="必填，请填写供应商名称"
        />
      </el-form-item>
      <el-form-item label="供应商地址" prop="address">
        <el-input
          v-model="editResourceSupplierInfo.address"
          placeholder="必填，请填写供应商地址"
        />
      </el-form-item>
      <el-form-item label="供应商联系方式" prop="tel">
        <el-input
          v-model="editResourceSupplierInfo.tel"
          placeholder="必填，请填写供应商联系方式"
        />
      </el-form-item>
      <el-form-item label="联系人姓名" prop="contactName">
        <el-input
          v-model="editResourceSupplierInfo.contactName"
          placeholder="必填，请填写联系人姓名"
        />
      </el-form-item>
      <el-form-item label="开户行">
        <el-input
          v-model="editResourceSupplierInfo.accountBank"
          placeholder="选填，请填写开户行"
        />
      </el-form-item>
      <el-form-item label="开户行账号">
        <el-input
          v-model="editResourceSupplierInfo.bankAccountNumber"
          placeholder="选填，请填写开户行账号"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="editResourceSupplierInfo.remark"
          type="textarea"
          placeholder="选填，请填写备注"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="editResourceSupplier">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateResourceSupplier } from '@/api/goods/resourceSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditResourceSupplier',
  data() {
    return {
      dialogVisible: false,
      editResourceSupplierInfo: {
        rsId: '',
        supplierName: '',
        address: '',
        tel: '',
        contactName: '',
        accountBank: '',
        bankAccountNumber: '',
        remark: ''
      },
      rules: {
        supplierName: [
          { required: true, message: '供应商名称不能为空', trigger: 'blur' },
          { max: 255, message: '供应商名称太长', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '供应商地址不能为空', trigger: 'blur' },
          { max: 255, message: '供应商地址太长', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '供应商联系方式不能为空', trigger: 'blur' },
          { max: 11, message: '供应商联系方式太长', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '联系人姓名不能为空', trigger: 'blur' },
          { max: 255, message: '联系人姓名太长', trigger: 'blur' }
        ],
        rsId: [
          { required: true, message: '供应商编号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.editResourceSupplierInfo = { ...row }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.editForm.resetFields()
      this.editResourceSupplierInfo = {
        rsId: '',
        supplierName: '',
        address: '',
        tel: '',
        contactName: '',
        accountBank: '',
        bankAccountNumber: '',
        remark: ''
      }
    },
    editResourceSupplier() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.editResourceSupplierInfo,
            shopId: getShopId()
          }
          updateResourceSupplier(params)
            .then(response => {
              console.log(response)
              this.$message.success('修改成功')
              this.closeDialog()
              this.$emit('refresh')
            })
            .catch(error => {
              this.$message.error(error.message || '修改失败')
            })
        }
      })
    }
  }
}
</script>